import { DateTime } from "luxon";

function formatDate(date: string): string {
  const dt = DateTime.fromISO(date, { zone: "utc" });
  if (!dt.isValid) {
    throw new Error(`formatDate received non-ISO input: ${date}`);
  }
  return dt.toUTC().toISO() ?? "";
}

export { formatDate };
